import React, { useState, useEffect, useCallback } from "react"
import CommonComponent, { validateTime } from "./CommonComponent"
import { useDispatch, useSelector } from "react-redux"
import _ from "lodash"
import { addOperatingHoursBusiness, addOperatingHoursAlchol } from "@reduxHelper"
import * as Adm from "@adm"

function BusinessHours({ editMode, setUpdate, isCreateMode = false, editingTheBusinnessHours, data, clearVal, setClearVal = () => { },
  setAllowUpdate = () => { }, isAllOkayRef = { current: true }, isTimeArrOkayRef = { current: true }, setAllowPrompt = () => { },
  preventRerender = false, setPreventRerender = () => { }, setFieldValue = () => { }, values = {}, errors = {}, touched = {},
  setAnyChanges = () => { }, setDaysArrState = () => { }, setTimeArrState = () => { }, daysArrState = [], timeArrState = [],
  setDaysError = () => { }, daysError = []
}) {
  const customDaysArr = [
    {
      day: "sunday",
      label: "S",
      selected: false,
    },
    {
      day: "monday",
      label: "M",
      selected: false,
    },
    {
      day: "tuesday",
      label: "T",
      selected: false,
    },
    {
      day: "wednesday",
      label: "W",
      selected: false,
    },
    {
      day: "thursday",
      label: "T",
      selected: false,
    },
    {
      day: "friday",
      label: "F",
      selected: false,
    },
    {
      day: "saturday",
      label: "S",
      selected: false,
    },
  ]
  const dispatch = useDispatch()
  const activeStep = useSelector((state) => state.stepperReducer.step)
  const timeObj = { time_from: "10:00", time_to: "23:00" }
  const reduxData = useSelector((state) => state.addLocationReducer)
  const [timeError, setTimeError] = useState([])
  const [alertMessage, setAlertMessage] = useState("")
  const [alert, setAlert] = useState(false)
  const [alertType, setAlertType] = useState("")

  useEffect(() => {
    setDaysArrState(_.get(data, "businessHrs.days", []))
    setTimeArrState(_.get(data, "businessHrs.time", []))
    let errArr = _.get(data, "businessHrs.time", _.get(reduxData, "operatingHoursBusiness.time", []))
      .map((x, i) => _.get(x, `[${i}].time_from`, "") > _.get(x, `[${i}].time_to`, ""))
    setTimeError(errArr)
  }, [data])

  useEffect(() => {
    if (clearVal === true) {
      setDaysArrState(_.get(data, "businessHrs.days", []))
      setTimeArrState(_.get(data, "businessHrs.time", []))
    }
    setClearVal(false)

  }, [clearVal, data])

  const clickHandler = (rowIdx, dayIdx) => {
    const newDaysArrState = [...daysArrState]
    newDaysArrState[rowIdx][dayIdx].selected = !newDaysArrState[rowIdx][dayIdx].selected
    if (!newDaysArrState[rowIdx].some((x) => x.selected === false)) {
      newDaysArrState[rowIdx].error = "Please select a day"
      isAllOkayRef.current = false
    } else {
      isAllOkayRef.current = true
    }
    setDaysArrState(newDaysArrState)
    setAnyChanges(true)
    setAllowUpdate(true)
    setAllowPrompt(true)
    validateTime({
      daysArrState: newDaysArrState,
      timeArrState,
      rowIdx,
      timeCheckKey: "between",
      setDaysError,
    })
  }

  const textChangeHandler = (val, type, i) => {
    const newTimeArrState = [...timeArrState]
    newTimeArrState[i][type] = val
    let tempAlcoholHoursTimeArr = _.cloneDeep(_.get(reduxData, "operatingHoursAlchol.time", []))
    tempAlcoholHoursTimeArr[i] = { time_from: "", time_to: "" }
    dispatch(addOperatingHoursAlchol({ days: daysArrState, time: tempAlcoholHoursTimeArr }))
    setFieldValue("businessHrs", { days: daysArrState, time: newTimeArrState })
    setTimeArrState(newTimeArrState)
    setAllowPrompt(true)
    setAllowUpdate(true)
    setAnyChanges(true)
  }
  const addHandler = (idx) => {
    setAlert(false)
    if ((daysArrState.length > 0 && daysArrState[idx].some((x) => x.selected === true)) || daysArrState.length === 0) {
      const newDaysArrState = [...daysArrState]
      const newTimeArrState = [...timeArrState]
      newTimeArrState.push(timeObj)
      newDaysArrState.push(customDaysArr)
      let tempAlcoholHoursTimeArr = _.cloneDeep(_.get(reduxData, "operatingHoursAlchol.time", []))
      tempAlcoholHoursTimeArr.push(timeObj)
      dispatch(addOperatingHoursAlchol({ days: newDaysArrState, time: tempAlcoholHoursTimeArr }))
      setFieldValue("businessHrs", { days: newDaysArrState, time: tempAlcoholHoursTimeArr })
      setDaysArrState(newDaysArrState)
      setTimeArrState(newTimeArrState)
      setAnyChanges(true)
    } else {
      const newDaysArrState = [...daysArrState]
      newDaysArrState[idx].error = "Kindly choose any of the days"
      setDaysError(newDaysArrState)
      setAlertType("error")
      setAlertMessage("Select atleast a day")
      setAlert(true)
    }
  }
  const closeHandler = (ind) => {
    const newDaysArrState = [...daysArrState]
    newDaysArrState[ind].error = ""
    const newTimeArrState = [...timeArrState]
    newDaysArrState.splice(ind, 1)
    newTimeArrState.splice(ind, 1)
    let tempAlcoholHoursTimeArr = _.cloneDeep(_.get(reduxData, "operatingHoursAlchol.time", []))
    tempAlcoholHoursTimeArr.splice(ind, 1)
    dispatch(addOperatingHoursAlchol({ days: newDaysArrState, time: tempAlcoholHoursTimeArr }))
    setFieldValue("businessHrs", { days: newDaysArrState, time: tempAlcoholHoursTimeArr })
    setAllowUpdate(true)
    setDaysArrState(newDaysArrState)
    setTimeArrState(newTimeArrState)
    setAnyChanges(true)
  }
  useEffect(() => {
    if (preventRerender === false) {
      dispatch(addOperatingHoursBusiness({ days: daysArrState, time: timeArrState }))
    }
    setPreventRerender(false)

  }, [preventRerender, daysArrState, timeArrState])

  useEffect(() => {
    isTimeArrOkayRef.current = timeError.filter((x) => x).length === 0

    return () => {
      let clonedTimeArr = _.cloneDeep(timeArrState)
      let indicesOfErr = timeError.reduce((acc, x, i) => {
        if (x === true) {
          acc.push(i)
          clonedTimeArr[i] = { time_from: "", time_to: "" }
        }
        return acc
      }, [])
      if (!_.isEmpty(indicesOfErr) && isCreateMode) {
        dispatch(addOperatingHoursBusiness({ days: [], time: [], dummy: true, }))
        dispatch(addOperatingHoursAlchol({ days: [], time: [], dummy: true }))
        setFieldValue("businessHrs", { days: [], time: [], dummy: true })
        setAnyChanges(true)
      }
    }
  }, [timeError])

  return (
    <>
      <CommonComponent
        daysArrState={daysArrState}
        timeArrErr={timeError}
        daysError={daysError}
        setTimeArrErr={setTimeError}
        setDaysError={setDaysError}
        timeArrState={timeArrState}
        clickHandler={clickHandler}
        textChangeHandler={textChangeHandler}
        addHandler={addHandler}
        closeHandler={closeHandler}
        setUpdate={setUpdate}
        isAllOkayRef={isAllOkayRef}
        isTimeMandatory
        markAsRequired
        displayText={"Business Hours"}
        editMode={editMode}
        setAnyChanges={setAnyChanges}
        errors={errors}
      />
      {alert ? (
        <Adm.SnackBar
          open={true}
          message={alertMessage}
          type={alertType}
          handleClose={() => setAlert(false)}
        />
      ) : null}
    </>
  )
}
export { BusinessHours }
export default BusinessHours
